var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.intro)?_c('div',{staticClass:"page-intro",style:({'padding-top': _vm.webWithoutNavigation ? '42px' : 0})},[_c('div',{staticClass:"intro-wrap"},[_c('img',{staticClass:"intro-img",attrs:{"src":_vm.intro.image,"alt":""}})]),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn-intro",attrs:{"href":"weixin://dl/"}},[_c('img',{attrs:{"src":require("./images/btn-intro.jpg"),"alt":""}})])
}]

export { render, staticRenderFns }